import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { TrackerProvider } from "@dpdgroupuk/react-event-tracker";
import { ThemeProvider } from "@material-ui/styles";

import theme from "./components/styles/theme";
import store from "./store";
import Routes from "./routes";
import { onUserAuth } from "./store/actions/user";
import { onAuthStateChanged } from "./services/auth";
import ErrorBoundary from "./components/ErrorBoundary";
import OverlayProvider from "./components/Overlay/Provider";
import SomethingWentWrong from "./components/SomethingWentWrong";
import Sentry from "./services/sentry";
import { tracker } from "./utils/eventTracker";

export default () => {
  const [loadingUser, setUserLoading] = useState(true);

  useEffect(
    () =>
      onAuthStateChanged(async (user) => {
        try {
          setUserLoading(true);
          await store.dispatch(onUserAuth(user));
          setUserLoading(false);
        } catch (e) {
          setUserLoading(false);
        }
      }),
    []
  );

  return (
    <Provider store={store}>
      <BrowserRouter>
        <TrackerProvider tracker={tracker}>
          <ThemeProvider theme={theme}>
            <OverlayProvider>
              <ErrorBoundary component={SomethingWentWrong} sentry={Sentry}>
                {loadingUser ? <></> : <Routes />}
              </ErrorBoundary>
            </OverlayProvider>
          </ThemeProvider>
        </TrackerProvider>
      </BrowserRouter>
    </Provider>
  );
};
